import { render } from "./TableHeadFilter.vue?vue&type=template&id=aca6dff6"
import script from "./TableHeadFilter.vue?vue&type=script&lang=js"
export * from "./TableHeadFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__